var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgServiceDelivery(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44 30C44 37.74 37.74 44 30 44L32.1 40.5",
    stroke: "#D12E29",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 18C4 10.26 10.26 4 18 4L15.9 7.5",
    stroke: "#D12E29",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4004 8.8999L35.3604 13.4999L43.2404 8.91992",
    stroke: "#242424",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3604 21.64V13.48",
    stroke: "#242424",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4802 4.42L28.6802 7.07991C27.6002 7.67991 26.7002 9.1999 26.7002 10.4399V15.52C26.7002 16.76 27.5802 18.28 28.6802 18.88L33.4802 21.54C34.5002 22.12 36.1802 22.12 37.2202 21.54L42.0202 18.88C43.1002 18.28 44.0002 16.76 44.0002 15.52V10.4399C44.0002 9.1999 43.1202 7.67991 42.0202 7.07991L37.2202 4.42C36.2002 3.86 34.5202 3.86 33.4802 4.42Z",
    stroke: "#242424",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.7002 30.8999L12.6402 35.4999L20.5402 30.9199",
    stroke: "#242424",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6401 43.64V35.48",
    stroke: "#242424",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.78 26.42L5.98001 29.0799C4.90001 29.6799 4 31.1999 4 32.4399V37.52C4 38.76 4.88001 40.28 5.98001 40.88L10.78 43.54C11.8 44.12 13.48 44.12 14.52 43.54L19.32 40.88C20.4 40.28 21.3 38.76 21.3 37.52V32.4399C21.3 31.1999 20.42 29.6799 19.32 29.0799L14.52 26.42C13.48 25.86 11.8 25.86 10.78 26.42Z",
    stroke: "#242424",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceDelivery);
export default __webpack_public_path__ + "static/media/service-delivery.8012cf4d945da6be027905ebe8595dba.svg";
export { ForwardRef as ReactComponent };